import React, { useEffect, useState } from 'react';
import useBillingStore from '../../../services/useBillingStore';
import FullScreenLoader from '../../FullScreenLoader/FullScreenLoader';

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount);
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR').format(date);
};

const getPaymentStatusBadgeClass = (status) => {
  const classes = {
    paid: 'badge-success',
    pending: 'badge-warning',
    failed: 'badge-danger',
    refunded: 'badge-primary'
  };
  return classes[status?.toLowerCase()] || 'badge-default';
};

const BillingHistory = () => {
  const { billingHistory, loading, error, fetchBillingHistory } = useBillingStore();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    fetchBillingHistory(currentPage, itemsPerPage);
  }, [currentPage, fetchBillingHistory]);

  if (loading) {
    < FullScreenLoader message="Carregando Histórico..." />
  }

  if (error) {
    return <div className="co-error">Erro ao carregar histórico: {typeof error === 'string' ? error : 'Erro desconhecido'}</div>;
  }

  const historyArray = Array.isArray(billingHistory) ? billingHistory : billingHistory?.items || [];

  if (historyArray.length === 0) {
    return (
      <div className="co-section">
        <h3>Histórico de Cobranças</h3>
        <div className="empty-state">Nenhum histórico de cobrança disponível.</div>
      </div>
    );
  }

  const totalItems = billingHistory?.total || historyArray.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <div className="co-section">
      <h3>Histórico de Cobranças</h3>

      <div className="billing-table-wrapper">
        <table className="billing-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Status</th>
              <th>Nota Fiscal</th>
            </tr>
          </thead>
          <tbody>
            {historyArray.map((item, index) => (
              <tr key={item.id || index}>
                <td>{formatDate(item.date)}</td>
                <td>{item.description}</td>
                <td>{formatCurrency(item.amount)}</td>
                <td>
                  <span className={`badge ${getPaymentStatusBadgeClass(item.status)}`}>
                    {item.status}
                  </span>
                </td>
                <td>
                  {item.invoice_url ? (
                    <button
                      className="btn-link"
                      onClick={() => window.open(item.invoice_url, '_blank')}
                    >
                      Baixar
                    </button>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            className="btn-secondary"
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            Anterior
          </button>
          <span className="pagination-info">
            Página {currentPage} de {totalPages}
          </span>
          <button
            className="btn-secondary"
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
          >
            Próxima
          </button>
        </div>
      )}
    </div>
  );
};

export default BillingHistory;
